import { FC } from 'react';
import { YoutubeScenario } from 'src/types/domain';
import Communicate from './Communicate';
import LearnImmerse from './LearnImmerse';
import * as S from './styles';

type LearnImmerseCommunicateProps = {
  cinema1: YoutubeScenario;
  ticketsLink: string;
  trailer1: YoutubeScenario;
};

const LearnImmerseCommunicate: FC<LearnImmerseCommunicateProps> = ({
  cinema1,
  ticketsLink,
  trailer1,
}) => {
  return (
    <S.Section>
      <S.SectionContent>
        <LearnImmerse scenario={trailer1} />
        <Communicate scenario={cinema1} ticketsLink={ticketsLink} />
      </S.SectionContent>
    </S.Section>
  );
};

export default LearnImmerseCommunicate;
